import { render } from "./EditFrequence.vue?vue&type=template&id=6a5eb027&scoped=true"
import script from "./EditFrequence.vue?vue&type=script&lang=js"
export * from "./EditFrequence.vue?vue&type=script&lang=js"

import "./EditFrequence.vue?vue&type=style&index=0&id=6a5eb027&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5eb027"]])

export default __exports__